// routes: [
//   {
//     companyCode: 'string',
//     companyName: 'string',
//     createBy: 'string',
//     departmentCode: 'string',
//     departmentCodes: ['string'],
//     departmentName: 'string',

//     departurePlaceCode: 'string',
//     departurePlaceDetail: 'string',
//     departurePlaceName: 'string',
//     departurePlaceType: 'string',
//     destinationCode: 'string',
//     destinationDetail: 'string',
//     destinationName: 'string',
//     destinationType: 'string',

//     remarks: 'string',
//     routeCode: 'string',
//     routeName: 'string',
//   },
// ],

export const chartColumns = [
  {
    field: 'routeName',
    title: '线路名',
    width: '200',
  },
  {
    field: 'routeCode',
    title: '线路Code',
    visible: false,
  },
  {
    field: 'departurePlaceName',
    title: '启运省市区',
    width: '150',
  },
  {
    field: 'departurePlaceDetail',
    title: '启运详细地址',
    width: '140',
  },
  {
    field: 'departurePlaceType',
    title: '启运位置类型',
    width: '140',
  },
  {
    field: 'destinationName',
    title: '目的省市区',
    width: '140',
  },
  {
    field: 'destinationDetail',
    title: '目的详细地址',
    width: '140',
  },
  {
    field: 'destinationType',
    title: '目的位置类型',
    width: '140',
  },
  {
    field: 'remarks',
    title: '备注',
    width: '140',
  },
];
